"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _PortalIdParser = _interopRequireDefault(require("PortalIdParser"));

var _noAuthApiClient = _interopRequireDefault(require("hub-http/clients/noAuthApiClient"));

var _createPublicI18nProvider = _interopRequireDefault(require("I18n/init/providers/createPublicI18nProvider"));

var _usageTrackerPublic = require("usage-tracker-public");

var _AuthActions = require("../actions/AuthActions");

var _ecosystemClient = require("../clients/ecosystemClient");

var _urls = require("../utils/urls");

var _usageTracker = require("../utils/usageTracker");

var _PublicApplication = _interopRequireDefault(require("../components/PublicApplication"));

var _App = _interopRequireDefault(require("../App"));

(0, _ecosystemClient.setApiBase)('ecosystem/public/v1');
var languageCode = window.I18N_MANUAL_LANG;
var I18nProvider = (0, _createPublicI18nProvider.default)({
  manuallySetLocale: true
});
I18nProvider.setLocale({
  locale: languageCode,
  langEnabled: true
});

var getPublicTrackerConfig = function getPublicTrackerConfig() {
  var trackerConfig = (0, _usageTracker.getTrackerConfig)('public');
  trackerConfig.isExternalHost = false;
  trackerConfig.properties = (0, _extends2.default)({}, trackerConfig.properties, {
    hubId: _PortalIdParser.default.get()
  });
  return trackerConfig;
};

var config = {
  ApplicationComponent: _PublicApplication.default,
  apiClient: _noAuthApiClient.default,
  blockingActions: [_AuthActions.checkUserLoggedIn],
  rootUrl: (0, _urls.getPublicRootUrl)(languageCode),
  usageTracker: (0, _usageTrackerPublic.createTracker)(getPublicTrackerConfig()),
  isPublic: true,
  I18nProvider: I18nProvider
};
new _App.default(config).start();


//////////////////
// WEBPACK FOOTER
// ./js/entries/publicStart.js
// module id = 1169
// module chunks = 212